import React from 'react';
export function HowItWorks() {
  const steps = [{
    number: '1',
    title: 'Revisa la próxima reunión',
    description: 'Consulta la fecha, hora, ubicación, enlace virtual, agenda y documentos disponibles.'
  }, {
    number: '2',
    title: 'Asiste o envía tu comentario',
    description: 'Puedes participar en persona, conectarte en línea o enviar comentarios según las opciones disponibles.'
  }, {
    number: '3',
    title: 'Mantente conectado',
    description: 'Suscríbete a alertas, revisa el calendario y vuelve a la página para conocer actualizaciones, proyectos y recursos.'
  }];
  return <section className="py-24 px-6 lg:px-8 bg-charcoal text-white" data-id="element-155">
      <div className="max-w-5xl mx-auto" data-id="element-156">
        <div className="text-center mb-16" data-id="element-157">
          <h2 className="text-3xl md:text-4xl font-bold text-softblue mb-4" data-id="element-158">
            Cómo Funciona
          </h2>
          <p className="text-xl text-softblue-dark max-w-2xl mx-auto" data-id="element-159">
            Participar es más fácil de lo que parece.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-160">
          <div className="hidden md:block absolute top-10 left-1/6 right-1/6 h-0.5 bg-charcoal-light z-0" data-id="element-161"></div>

          {steps.map((step, index) => <div key={index} className="relative z-10 flex flex-col items-center text-center" data-id="element-162">
              <div className="w-20 h-20 bg-warm rounded-full flex items-center justify-center text-3xl font-bold text-charcoal mb-6 shadow-lg border-4 border-charcoal" data-id="element-163">
                {step.number}
              </div>
              <h3 className="text-xl font-bold text-softblue mb-4" data-id="element-164">
                Paso {step.number}: {step.title}
              </h3>
              <p className="text-softblue-dark leading-relaxed" data-id="element-165">
                {step.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}